const ITEMS = [
  "Fascia — the body's connective web",
  "Chest Wall Decompression",
  "Fascia Stretch Therapy",
  "Myofascial Release",
  "Therapeutic Massage",
  "Nervous-System Regulation",
  "Reflexology",
  "Thai Massage",
  "Facial Sculpting & Buccal",
  "Reiki",
  "Breathwork",
];

export const Marquee = () => (
  <div className="relative overflow-hidden border-b border-white/10 py-7 bg-ink2/40 marquee-paused" data-testid="marquee">
    <div className="marquee-track flex w-max animate-marquee items-center">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
          {ITEMS.map((item, i) => (
            <span key={`${dup}-${i}`} className="flex items-center whitespace-nowrap">
              <span className={`px-8 text-xl sm:text-2xl font-light ${i % 2 === 0 ? "font-serif italic text-ivory/80" : "font-mono text-[11px] uppercase tracking-[0.3em] text-mute"}`}>
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" aria-hidden="true" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
